const STATUS_LABELS: Record<string, string> = {
  ABERTA: 'Aberta',
  EM_CONTAGEM: 'Em contagem',
  PARCIALMENTE_RETIRADA: 'Parcialmente retirada',
  CONFERIDA: 'Conferida',
  DIVERGENTE: 'Divergente',
  FINALIZADA: 'Finalizada',
  CANCELADA: 'Cancelada'
};

export function statusLabel(status: string | null | undefined) {
  const value = String(status || '').trim();
  if (!value) return '-';

  return STATUS_LABELS[value] || value
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/^\w|\s\w/g, (letter) => letter.toUpperCase());
}
